import { style, keyframes } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

const scrollLeft = keyframes({
  '0%': { transform: 'translateX(0)' },
  '100%': { transform: 'translateX(-50%)' },
});

const scrollRight = keyframes({
  '0%': { transform: 'translateX(-50%)' },
  '100%': { transform: 'translateX(0)' },
});

export const marqueeContainer = style(
  {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    maskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
    WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
  },
  'marquee-container',
);

export const marqueeRow = style(
  {
    display: 'flex',
    gap: themeVars.space['100'],
    width: 'max-content',
    paddingBlock: themeVars.space['050'],
  },
  'marquee-row',
);

export const marqueeRowScrollLeft = style(
  {
    animation: `${scrollLeft} 60s linear infinite`,

    '@media': {
      '(prefers-reduced-motion: reduce)': {
        animation: 'none',
      },
    },
  },
  'marquee-row-scroll-left',
);

export const marqueeRowScrollRight = style(
  {
    animation: `${scrollRight} 60s linear infinite`,

    '@media': {
      '(prefers-reduced-motion: reduce)': {
        animation: 'none',
      },
    },
  },
  'marquee-row-scroll-right',
);

export const marqueeRowPaused = style(
  {
    animationPlayState: 'paused',
  },
  'marquee-row-paused',
);

export const marqueeWrapper = style(
  {
    display: 'flex',
    flexDirection: 'column',
    gap: themeVars.space['050'],
    width: '100%',
  },
  'marquee-wrapper',
);
